module.exports = __webpack_public_path__ + "img/media_works_abstract_thumb.6cf3a8ba.jpg";